<template>
  <div class="animated fadeIn">
    <b-jumbotron bg-variant="white" text-variant="dark">
      <template v-slot:lead>
        <h2>سوالات متداول</h2>
        <hr />
        <b-card v-for="(item, index) in faqs" :key="index" class="mb-2" no-body>
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle="'faq-' + index"
              variant="link"
              class="text-right"
            >
              {{ index + 1 }}. {{ item.question }}
            </b-button>
          </b-card-header>
          <b-collapse
            :id="'faq-' + index"
            accordion="faq-accordion"
            role="tabpanel"
          >
            <b-card-body
              v-html="item.answer"
              class="text-right text-justify"
            ></b-card-body>
          </b-collapse>
        </b-card>
        <hr />
        <p class="text-right text-justify">
          جهت دریافت اطلاعات بیشتر و دسترسی به پروفایل دانشگاه، می‌توانید با
          سرکار خانم قدیری، کارشناس ستاد توسعه زیست‌فناوری، سلامت و فناوری‌های
          پزشکی با شماره‌های ۰۲۱-۸۸۰۳۱۵۸۳ و ۰۲۱-۸۳۵۳۰ داخلی ۷۴۳۲ و 7431 و یا
          شماره همراه ۰۹۳۵۴۲۶۸۵۹۳، تماس حاصل فرمایید.
        </p>
      </template>
    </b-jumbotron>
  </div>
</template>

<script>
export default {
  data() {
    return {
      faqs: [
        {
          question:
            "طرح تقسیم کار ملی زیست‌فناوری چیست و با چه هدفی اجرا می‌شود؟",
          answer:
            "این طرح با هدف تمرکز‌بخشی به فعالیت‌های پژوهشی، تخصصی‌سازی مأموریت‌های مراکز علمی و ارتقای زیست‌بوم فناوری کشور در حوزه زیست‌فناوری اجرا می‌شود.",
        },
        {
          question: "اجرای این طرح بر چه مبنایی انجام پذیرفته است؟",
          answer: `
            <ul>
              <li>•	تحلیل پیشرفته فناوری‌های زیستی با استفاده از مدل‌های زبانی هوش مصنوعی (NLP).</li>
              <li>•	داده‌کاوی مقالات علمی ایرانی از طریق اتصال به پایگاه‌های Scopus و PubMed.</li>
              <li>•	رده‌بندی مراکز منتخب بر اساس کیفیت مقالات با تمرکز بر نمایه‌های Q1 و Q2.</li>
              <li>•	دسته‌بندی مقالات در ۴۰ حوزه فناوری زیستی براساس ویژگی‌های معنایی استخراج‌شده.</li>
              <li>•	پیونددهی هوشمند (Mapped Intelligence) میان فناوری‌های زیستی و بدنه علمی کشور.</li>
              <li>•	واگذاری هدفمند فناوری‌ها به مراکز منتخب مطابق ظرفیت علمی و توان جذب.</li>
            </ul>
          `,
        },
        {
          question:
            "این طرح بر چه اساسی طراحی شده و چه نهادهایی در اجرای آن مشارکت دارند؟",
          answer:
            "طرح تقسیم کار ملی زیست‌فناوری، بر پایه تحلیل داده‌های علم‌سنجی و اسناد بالادستی طراحی شده و با همکاری «ستاد توسعه زیست‌فناوری، سلامت و فناوری‌های پزشکی، معاونت علمی، فناوری و اقتصاد دانش‌بنیان ریاست جمهوری»، «وزارت علوم، تحقیقات و فناوری»، «وزارت بهداشت، درمان و آموزش پزشکی»، «سازمان برنامه و بودجه کشور»، « موسسه ملی توسعه تحقیقات علوم پزشکی ایران (نیماد)»، «صندوق نوآوری و شکوفایی» و دیگر نهادهای علمی و پژوهشی کشور اجرا می‌شود.",
        },
        {
          question: "تفاوت بین «موضوع» و «محور» در این طرح چیست؟",
          answer:
            '"موضوعات"، دسته‌بندی‌های اصلی فناوری‌های زیستی هستند و "محورها" به‌عنوان زیرمجموعه‌های تخصصی هر موضوع تعریف شده‌اند.',
        },
        {
          question: "کدام مراکز مشمول این طرح هستند و چگونه انتخاب شده‌اند؟",
          answer:
            "دانشگاه‌ها، پژوهشگاه‌ها، پژوهشکده‌ها و مراکز تحقیقاتی دارای ردیف بودجه مستقل.",
        },
        {
          question:
            "آیا مراکز فاقد ردیف بودجه مستقل امکان ثبت در سامانه دارند؟",
          answer:
            "در این مرحله خیر، در گام‌های بعدی اجرای طرح تقسیم کار ملی زیست‌فناوری، امکان سنجی حضور مراکز فاقد ردیف بودجه مستقل صورت خواهد پذیرفت.",
        },
        {
          question: "محل تامین اعتبارات این طرح توسط چه نهادهایی تأمین می‌شود؟",
          answer: `
            <ul>
              <li>•	سازمان برنامه و بودجه کشور</li>
              <li>•	موسسه ملی توسعه تحقیقات علوم پزشکی ایران (نیماد)</li>
              <li>•	صندوق نوآوری و شکوفایی</li>
              <li>•	 بنیاد ملی علم ایران و سایر نهادهای پژوهشی نقش تأمین مالی دارند</li>
             </ul>
          `,
        },
        {
          question: "نحوه ورود به سامانه چگونه است؟",
          answer:
            'از طریق سامانه به نشانی <a href="https://biodcportal.com" target="_blank">https://biodcportal.com</a> و انتخاب گزینه «ورود دانشگاه»، نماینده مرکز می‌تواند وارد پروفایل شود.',
        },
        {
          question: "اطلاعات ورود (نام کاربری و رمز عبور) را چگونه دریافت کنیم",
          answer:
            "در صورت عدم دسترسی به اطلاعات پروفایل و یا فراموشی رمز عبور، نماینده رسمی هر مرکز می‌تواند با کارشناس مربوطه در ستاد تماس گرفته و اطلاعات ورود را به صورت مستقیم دریافت نماید.",
        },
        {
          question: "آیا پس از ثبت نهایی اطلاعات امکان ویرایش وجود دارد؟",
          answer:
            "خیر. تنها تا قبل از ثبت نهایی، امکان ذخیره به‌صورت پیش‌نویس و ویرایش مستندات وجود دارد.",
        },
        {
          question:
            "در صورت مشاهده مغایرت در موضوعات ابلاغ‌شده چه اقدامی باید انجام شود؟",
          answer:
            "در این مرحله هر مرکز می‌تواند حداکثر 2 موضوع انتخاب کند. همچنین در این مرحله، محدودیتی جهت انتخاب محور وجود ندارد.",
        },
        {
          question: "پس از تأیید مأموریت توسط مرکز، مراحل بعدی چیست؟",
          answer:
            "مرکز می‌بایست برنامه اجرایی خود را در پروفایل بارگذاری کرده و وارد مرحله تعامل، بازبینی و جلسات هماهنگی با ستاد شود.",
        },
        {
          question: "برنامه اجرایی باید دارای چه ویژگی‌هایی باشد؟",
          answer:
            "برنامه‌های اجرایی می‌بایست منطبق با ظرفیت علمی مرکز، مأموریت تخصیص‌یافته و اسناد علمی مرتبط باشد.",
        },
        {
          question: "آیا شرکت در این طرح برای همه مراکز الزامی است؟",
          answer:
            "با عنایت به آنکه طبق توافقات صورت گرفته، مبنای تخصیص اعتبار پژوهشی برای مراکز پیشگفت منوط به همکاری سامانه طرح تقسیم کار ملی می‌باشد. شرکت در این طرح الزامیست.",
        },
        {
          question:
            "در صورت تغییر ساختار یا اطلاعات مرکز، چه اقدامی باید صورت گیرد؟",
          answer:
            "نماینده مرکز موظف است اطلاعات به‌روزرسانی‌شده را در سامانه وارد و مستندات مرتبط را بارگذاری کرده و موضوع را به اطلاع ستاد برساند.",
        },
        {
          question: "نحوه اطلاع رسانی برنامه اجرایی و گزارش دوره‌ای چگونه است؟",
          answer:
            "پس از بررسی و تائید نهائی موضوعات و محورها، بخش بارگذاری مستندات در پروفایل مرکز فعال خواهد شد.",
        },
        {
          question: "چه فرمتی برای بارگذاری مستندات قابل قبول است؟",
          answer:
            "فایل Jpeg ,Png ,Pdf , Word ,Excel با حجم کمتر از ۵ مگابایت پذیرفته می‌شوند.",
        },
        {
          question: "آیا نتایج این طرح در حمایت‌های مالی آینده تأثیر دارد؟",
          answer:
            "بله؛ حمایت‌های پژوهشی آتی، صرفاً بر اساس مأموریت‌های تأییدشده در سامانه انجام خواهد پذیرفت.",
        },
        {
          question: "سوابق ثبت‌شده در سامانه چگونه قابل مشاهده است؟",
          answer:
            "تمامی سوابق، مستندات و بازخوردها از طریق داشبورد کاربری نماینده در سامانه قابل پیگیری است.",
        },
        {
          question: "در صورت بروز مشکل فنی در سامانه چه اقدامی باید کرد؟",
          answer:
            "از طریق فرم پشتیبانی داخل سامانه پیام ارسال شود و یا با کارشناس مربوطه در ستاد تماس حاصل گردد.",
        },
      ],
    };
  },
};
</script>

<style scoped>
* {
  font-family: iransans;
  direction: rtl;
}
.b-button {
  text-align: right;
}
</style>
